export const MIN_SMALL_EMPTY_SLOT = 15
export const MIN_HIDDEN_EMPTY_SLOT = 3
export const MIN_MEDIUM_BOOKED_SLOT = 45
export const MIN_SLOT_DURATION_FOR_SUGGESTION = 60
export const MAX_SLOT_DURATION_FOR_SUGGESTION = 180
